import { useMutation, useQueryClient } from '@tanstack/react-query';

import { signatureKeys } from './keys';
import { postSignatureUpload } from './signatureApi';
import type { ClinicianSignatureT, SignatureUploadT } from './signatureTypes';

/** Upload mutation: replace the saved PNG bytes. Seeds the React
 *  Query cache with the server-returned record so the preview updates
 *  before the followup invalidate-and-refetch lands -- keeps the
 *  panel feeling instantaneous.
 */
export function useSignatureUploadMutation() {
  const queryClient = useQueryClient();
  return useMutation<ClinicianSignatureT, Error, SignatureUploadT>({
    mutationFn: (upload) => postSignatureUpload(upload),
    onSuccess: (data) => {
      queryClient.setQueryData(signatureKeys.all, data);
      void queryClient.invalidateQueries({ queryKey: signatureKeys.all });
    },
  });
}
